// Otomatik Mail Raporları sayfası kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'documents.mailReports';

export const mailReportsGuide = (t: TFunction): GuideContent => ({
  layout: 'tabbed',
  title: t(`${G}.title`, 'Otomatik Mail Raporları nasıl kullanılır?'),
  intro: t(`${G}.intro`, 'Gün sonu raporlarının belirlediğiniz saatlerde e-posta ile otomatik gönderilmesini bu sayfadan yönetirsiniz. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Başlık'),
    tabs: t(`${G}.regions.tabs`, 'Sekmeler'),
    body: t(`${G}.regions.body`, 'Sekme içeriği'),
  },
  navItems: [
    t(`${G}.nav.schedules`, 'Zamanlamalar'),
    t(`${G}.nav.logs`, 'Çalışma Logları'),
    t(`${G}.nav.template`, 'Şablon / Branding'),
    t(`${G}.nav.smtp`, 'SMTP'),
  ],
  steps: [
    {
      region: 'header',
      title: t(`${G}.s1.title`, '1. Bu sayfa ne işe yarar?'),
      text: t(`${G}.s1.text`, 'Günlük, haftalık ve aylık gün sonu raporları seçtiğiniz kişilere otomatik mail olarak gider. Ne zaman ve kime gideceğini, mailin görünümünü ve gönderim geçmişini buradan yönetirsiniz.'),
      tips: [
        t(`${G}.s1.tip1`, 'Modül şirketiniz için kapatılmışsa sayfa yerine "Modül Devre Dışı" uyarısı görünür; açtırmak için destek ile iletişime geçin.'),
      ],
    },
    {
      region: 'tabs',
      title: t(`${G}.s2.title`, '2. Zamanlamalar: raporu planlayın'),
      text: t(`${G}.s2.text`, '"Yeni Zamanlama" ile hangi raporun, hangi şubeler için, hangi saatte ve kimlere gideceğini belirleyin. Listede her zamanlamanın son ve sonraki çalışma zamanı, alıcıları ve Aktif / Pasif durumu görünür.'),
      tips: [
        t(`${G}.s2.tip1`, 'Satırdaki uçak düğmesi (Test mail gönder) raporu hemen alıcılara yollar; şube seçiliyse her şube için ayrı mail gider.'),
        t(`${G}.s2.tip2`, 'Silinen zamanlamanın otomatik gönderimi durur ve bu işlem geri alınamaz; geçmiş çalışma logları korunur. Geçici durdurmak için zamanlamayı silmek yerine Pasif yapın.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s3.title`, '3. Çalışma Logları: gönderimi kontrol edin'),
      text: t(`${G}.s3.text`, 'Her gönderimin tarihi, kaynağı (Zamanlı, Test, Manuel), durumu, süresi, alıcı sayısı ve ciro bilgisi listelenir. Tümü / Başarılı / Başarısız / Atlandı düğmeleriyle süzün; satırı açarak konu, alıcılar ve hata ayrıntısını görün.'),
      tips: [
        t(`${G}.s3.tip1`, 'Başarılı / Başarısız / Atlandı kartları yalnız o sayfadaki kayıtları sayar; Toplam Çalışma tüm kayıtları gösterir.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s4.title`, '4. Şablon / Branding: mailin görünümü'),
      text: t(`${G}.s4.text`, 'Marka adı, renkler, logo ve alt bilgi metni tüm mail raporlarınızda kullanılır. "Kaydet" ile şirketinize özel şablonu saklayın; hiç kaydetmediyseniz genel varsayılan şablon kullanılır. "Mail Önizle" ile seçtiğiniz zamanlamanın mailini önceden görün.'),
      tips: [
        t(`${G}.s4.tip1`, 'Logo için adres yazabilir ya da "Kütüphane" düğmesiyle yüklü bir resim seçebilirsiniz.'),
        t(`${G}.s4.tip2`, 'Tam HTML alanı ileri seviye içindir; boş bırakırsanız standart şablon kullanılır.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s5.title`, '5. SMTP: mailin gönderildiği sunucu'),
      text: t(`${G}.s5.text`, 'SMTP bilgileri merkezi olarak SuperAdmin tarafından yönetilir; bu sekmede yalnız okunur olarak görürsünüz. Şirketiniz için özel bir SMTP atanmadıysa Aquasoft\'un genel varsayılan SMTP\'si kullanılır ("Aquasoft Global Default" etiketi).'),
      tips: [
        t(`${G}.s5.tip1`, 'Değişiklik gerekiyorsa sekmedeki destek adresiyle iletişime geçin.'),
        t(`${G}.s5.tip2`, 'SuperAdmin için bu sekme düzenlenebilir: şifreler şifreli saklanır ve ekranda geri gösterilmez; düzenlerken şifreyi boş bırakırsanız önceki şifre korunur.'),
      ],
    },
  ],
});
